module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"signal_strength":{"strong":"強","middle":"中","weak":"弱","poor":"微弱","none":"圏外","unknown":"--"}},"en":{"signal_strength":{"strong":"Strong","middle":"Middle","weak":"Weak","poor":"Poor","none":"Out of range","unknown":"--"}}}')
  delete Component.options._Ctor
}
